import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ProgressActions from '../../actions/progress';

export class FederationProgress extends React.Component {
  static propTypes = {
    activeIndex: PropTypes.number,
    currentStep: PropTypes.shape({
      progress: PropTypes.shape({
        stepType: PropTypes.string,
      }),
    }),
    actions: PropTypes.shape({
      progress: PropTypes.object,
    }),
  };

  shouldComponentUpdate(nextProps) {
    const { activeIndex, currentStep: { progress } = {} } = this.props;
    return nextProps.activeIndex > activeIndex && !!progress;
  }

  componentDidUpdate(prevProps) {
    const { progress } = prevProps.currentStep || {};
    this.props.actions.progress.post({
      items: [{ ...progress }],
    });
  }

  render() {
    return null;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      progress: bindActionCreators(ProgressActions, dispatch),
    },
  };
};

export default connect(null, mapDispatchToProps)(FederationProgress);



// WEBPACK FOOTER //
// ./src/App/account/components/Onboarding/FederationProgress.js